<template>

  <thead>

    <tr>

      <th class="cart__th">
        Item
      </th>

      <th class="cart__th">
        Quantidade
      </th>

    </tr>

  </thead>

</template>

<script>
  export default {
    name: "TableHead"
  }
</script>
